<template>
  <div id="resources" class="mt-3">
    <h2>Information Resources</h2>
    <a href="https://fidelior.net/wp-content/uploads/2019/12/FideliorJournalLists-Green-002.pdf" class="btn btn-outline-info w-100 mb-3" role="button">Green Lists (trustworthy)</a>
    <a href="http://fidelior.net/wp-content/uploads/2019/12/Fidelior-Orange-List.pdf" class="btn btn-outline-info w-100 mb-3" role="button">Orange Lists (doubtful)</a>
    <a href="https://fidelior.net/wp-content/uploads/2019/12/Fidelior-Terms-of-Use-1.pdf" class="btn btn-outline-info w-100 mb-3" role="button">Terms of Use</a>
    <a href="https://fidelior.net/blog/" target="_blank" class="btn btn-info w-100" role="button">Blog&nbsp;<font-awesome-icon icon="external-link-alt" :style="{ color: 'fefefe' }" /></a>
  </div>
</template>

<script>
export default {};
</script>